let detach = null;

export function registerSlicePreviewDetach(fn) {
  detach = fn;
}

/** Run registered GPU preview teardown once (before trim replaces geometry). */
export function runSlicePreviewDetach() {
  const fn = detach;
  detach = null;
  if (fn) fn();
}
